export default __webpack_public_path__ + "static/media/IMG_5373.15e1ddd8.WEBP";